<template>
    <div>
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <div v-for="item in swiperlist" :key="item.id" :style="'background-image:url('+item.imageUrl+')'" v-bind:alt="item.title" class="swiper-slide"><a v-bind:href="item.link"></a></div>
            </div>
            <!-- 如果需要分页器 -->
            <div class="swiper-pagination"></div>
            
            <!-- 如果需要导航按钮 -->
            <div class="swip-btn">
            	<div class="swiper-button-prev"><span></span></div>
            	<div class="swiper-button-next"><span></span></div> 
            </div>
        	
        </div>
    </div>
</template>
<script>
export default {
  name: 'banner',
  data () {
    return {
      swiperlist:[]
    }
  },
  methods:{
    getbannerlist:function(){
      var _this = this;
      var posturl = _this.apilist.banner+'7/1/10';
      _this.getData(posturl,function(data){
        if(data.code=='0')
        { 
          for(var i in data.data.list)
          {
            if(data.data.list[i].imageUrl!=''&&data.data.list[i].imageUrl!=null)
            {
              _this.swiperlist.push(data.data.list[i]);
            }
          }
        }
        _this.$nextTick(function(){
          var mySwiper = new Swiper ('.swiper-container', {
            autoplay:5000,
            loop: true,
            autoplayDisableOnInteraction:false,
            pagination: '.swiper-pagination',
          })     
      $('.swiper-button-prev').click(function(){
			 mySwiper.swipePrev(); 
			})
			$('.swiper-button-next').click(function(){
			 mySwiper.swipeNext(); 
			})
        })
        
      })
    }
  },
  mounted(){
    this.getbannerlist()
  },
  components:{
  }
}
</script>


// WEBPACK FOOTER //
// banner.vue?02885497